export default __webpack_public_path__ + "9dbac7d384e75fc9108bf0fd9403701a.png";